import { AbstractRenderer, BusinessComponent, BusinessComponentOptions } from '@blk/simba';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ComponentData } from '@ddt-web/data-service';

import { TpmDisclosureComponent } from '../../disclaimers/tpm-disclosure.component';
import { PerformanceDisclaimerUtil } from '../util/performance-disclaimer.util';
import { PerformanceVisibilityUtil } from '../util/performance-visibility.util';

export class PerformanceDisclaimerComponent extends BusinessComponent {
	@InjectConfig(SharedConfigKey.EnableCustomFee) private readonly isCustomFeeEnabled: boolean = false;

	constructor(
		name: string,
		public dataComponentId: string,
		public customAdvisoryFee: number = null,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		return PerformanceVisibilityUtil.isPerformanceComponentDataVisible(componentData, this.isCustomFeeEnabled, this.customAdvisoryFee);
	}

	public buildComponent(componentData: ComponentData): AbstractRenderer<SVGGElement>[] {
		let panels: AbstractRenderer<SVGGElement>[] = [];

		if (this.isComponentDataVisible(componentData)) {
			if (this.isCustomFeeEnabled) {
				panels = [...panels, ...PerformanceDisclaimerUtil.customFeeEnabledDisclaimer('PDF_PERFORMANCE_DISCLAIMER_')];
			} else {
				panels.push(
					PerformanceDisclaimerUtil.noCustomFeeEnabledDisclaimer('NO_NET_PERF_DISCLOSURE')
				);
			}

			const tpmDisclosure = new TpmDisclosureComponent('TPM Disclosure');
			panels.push(...tpmDisclosure.buildComponent());
		}


		return panels;
	}
}
